<template>
    <div class="aside_all">
        <el-input @keyup.enter.native="toFilterData" placeholder="请输入项目名称" v-model="input1">
            <template slot="prepend">项目名称</template>
        </el-input>
        <el-tabs v-model="activeName">
            <el-tab-pane label="全部" name="first">
                <el-table :show-header="false" v-loading="loading" @row-click="editRow" border :data="projectData" height="350" style="width: 100%">
                    <el-table-column align="center" prop="project" label="全部项目"></el-table-column>
                </el-table>
                <el-pagination @current-change="pageChanged" :current-page="filters.pagination.page" layout="total,prev, pager, next" :total="filters.pagination.total"></el-pagination>
            </el-tab-pane>
            <el-tab-pane label="项目" name="second">
                <el-container>
                    <el-aside width="33.3%" class="pend">
                        <div v-for="(item,index) in projectChooseData" :key="index">
                            <div :class="idx==index?'hover':''" @click="tab(item,index)" class="tabValue">{{item.projectCategory}}</div>
                        </div>
                    </el-aside>
                    <el-aside width="33.3%" class="pend">
                        <div v-for="(item,index) in projectChildData" :key="index">
                            <div :class="childIndex==index?'hover':''" @click="tabData(item,index)" class="tabValue">{{item.projectName}}</div>
                        </div>
                    </el-aside>
                    <el-aside width="33.3%" class="pend">
                        <div v-for="(item,index) in projectChildList" :key="index">
                            <div @click="editRow(item)" class="tabValue">{{item.project}}</div>
                        </div>
                    </el-aside>
                </el-container>
                <el-pagination class="pagination" @current-change="pageChanged1" :current-page="counts.pagination.page" layout="total,prev, pager, next" :total="counts.pagination.total"></el-pagination>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { v4 as uuidv4 } from "uuid";
export default {
    props: ['purData', 'userInfo'],
    data() {
        return {
            input1: '',
            projectData: [],
            projectChildData: [],
            projectChildList: [],
            idx: 0,
            childIndex: 0,
            filters: {
                pagination: {
                    page: 1,
                    limit: 10,
                    total: 0
                },
            },
            counts: {
                pagination: {
                    page: 1,
                    limit: 10,
                    total: 0
                },
            },
            projectList: [],
            aaList: [],
            projectChooseData: [],
            activeName: 'second',
            loading: false,
        }
    },
    created() {
        this.$nextTick(() => {
            this.init()
            this.toChooseData()
        });
    },
    computed: {
        ...mapState(["",]),
        ...mapGetters(["productOptions",]),
    },
    methods: {
        testSX() {
            this.$forceUpdate();
        },
        pageChanged(page) {
            this.filters.pagination.page = page
            this.projectData = this.projectList.slice((page - 1) * this.filters.pagination.limit, page * this.filters.pagination.limit)
        },
        pageChanged1(page) {
            this.counts.pagination.page = page
            this.projectChildList = this.aaList.slice((page - 1) * this.counts.pagination.limit, page * this.counts.pagination.limit)
        },
        // //查询 
        toFilterData(val) {
            // console.log('0000000000');
            // 请求查询接口，将列表展现出来
            this.activeName = 'first'
            this.init()
        },
        init() {
            this.loading = true
            setTimeout(() => {
                // console.log(this.productOptions);
                this.projectList = _g.paramMatch(this.productOptions, this.projectList, this.input1, 'project')
                // 给筛选出的内容进行分页显示
                this.projectData = this.projectList.slice(0, this.filters.pagination.limit)
                // console.log(this.projectData);
                this.filters.pagination.total = this.projectList.length
                this.filters.pagination.page = 1
                this.loading = false
                // console.log(this.projectList);
            }, 1000);
        },
        toChooseData() {
            let data = {
                project: '',
            }
            api.requestQuiet("/skn/findProjectClassificationList", data, (res) => {
                if (res.result == true) {
                    // 一类
                    this.projectChooseData = res.data
                    // console.log(res.data);
                    // 二类
                    this.projectChildData = this.projectChooseData[0].children
                    // 三类
                    this.aaList = this.projectChildData[0].children
                    // console.log(this.aaList);
                    this.projectChildList = this.aaList.slice(0, this.counts.pagination.limit)
                    // console.log(this.projectChildList);
                    this.counts.pagination.total = this.aaList.length
                } else {
                    _g.toast("error", res.errMsg);
                }
            }, (err) => { });
        },
        tab(item, index) {
            this.idx = index
            this.childIndex = 0
            if (item.children != null) {
                this.projectChildData = item.children
                // console.log('item');
                // console.log(item);
            } else {
                this.projectChildData = []
            }
            if (item.children != null) {
                this.aaList = item.children[0].children
                this.projectChildList = this.aaList.slice(0, this.counts.pagination.limit)
                this.counts.pagination.total = this.aaList.length
                this.counts.pagination.page = 1
            } else {
                this.projectChildList = []
            }
        },
        tabData(item, index) {
            // console.log('第二类');
            // console.log(item);
            this.childIndex = index
            this.aaList = item.children
            this.projectChildList = this.aaList.slice(0, this.counts.pagination.limit)
            this.counts.pagination.total = this.aaList.length
            this.counts.pagination.page = 1
        },
        editRow(row) {
            console.log(row);
            this.purData.push({
                project: row.project,
                projectName: row.project,
                projectId: row.id,
                projectReplenish: '',
                purchaseNumber: '',
                projectAmt: '',
                createTime: this.userInfo.sknDate,
                purchaseRemark: '',
                purchaseId: uuidv4(),
                projectType: '1',//购买/赠送
                isCreate: true,//是否创建
                isUpdate: false,//是否修改 
            })
            console.log(this.purData);
        },
    }
}
</script>
<style scoped>
.aside_all {
  border: 1px solid #eee;
}
.aside_all >>> .el-tabs__header {
  margin: 0px;
}
.pend {
  height: 320px;
  overflow: scroll;
  /* border: 1px solid red; */
}
.tabValue {
  border: 1px solid #eee;
  cursor: pointer;
  /* height: 30px; */
  padding: 5px;
  box-sizing: border-box;
  font-size: 14px;
}
.hover {
  color: #409eff;
}
.pagination {
  text-align: center;
}
</style>



